/**
 * ============================================================================
 * MATCHLESS CABINET PLATFORM: PLANNER INTEGRATION APPLICATION V2
 * Component: mc_planner.js
 * ============================================================================
 */

// Global Helper: Match powder coat finish colors to specific manufacturing codes
function getColorCode(color){
    switch(color){
      case "Ash":
        return "Hilltop Silver PLS-2334";
      case "Artic Vein":
        return "Grey Black Vein PVS-4775";
      case "Silver Vein":
        return "Silver Vein PS-1231-GT";
      case "Sandstone":
        return "Sandstone PS0261-H";
      case "Cappuccino":
        return "Ridgerock PLB-11221";
      case "Chestnut":
        return "Java 9316-8644M-2";
      case "Charcoal":
        return "Sam Grey Hammer 9415-71531";
      case "Gloss White":
        return "Sky White Peel 9333-91262";
      case "Gloss Blue":
        return "Blue Peel 9213-52229";
      case "Blue Speckle":
        return "Blue Speckle 9316-74583M";
      case "Gloss Black":
        return "Poly Black Peel 9313-9000";
      case "Sage":
        return "Green Gray Texture 9012-74683";
      case "Champagne":
        return "Champagne PTS-7092";
      case "Matte White":
        return "Soft White PTS-4456";
      case "Matte Black":
        return "Texture Black 8225224";
      case "Matte Blue":
        return "Old Navy PTB-6882";
      case "Matte Navy":
        return "Blue Tex RAL-5008";
      case "Walnut":
        return "Walnut PTS-4749";
      default:
        return color;
    }
}

// Global Form Validation Engine Configuration (Iodine)
Iodine.setErrorMessage('required', 'Selection is required');
const VALID_NUMBER_REGEX = /^-?\d+(\.\d+)?$/;

Iodine.rule('cutoutDim', (value) => VALID_NUMBER_REGEX.test(value));
Iodine.setErrorMessage('cutoutDim', "Value must be a number or decimal. For fractions, convert to decimal first.");


// ============================================================================
// STOREFRONT GRAPHQL WORKFLOW (ALL 4 VALUES AS METAFIELDS)
// ============================================================================
const STOREFRONT_ACCESS_TOKEN = '38ccb3dbf09a955fcb1839c518288034'; 
const SHOP_DOMAIN = window.location.hostname;
const GRAPHQL_URL = `https://${SHOP_DOMAIN}/api/2026-04/graphql.json`;

/**
 * Asynchronously fetches the native, non-expiring Shopify Online Store cart token string
 * Bypasses deprecated privacy-restricted global analytics objects safely.
 */
async function getCurrentCartToken() {
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error('Failed to fetch Shopify cart data');
        const cart = await response.json();
        return cart.token;
    } catch (error) {
        console.error("Failed to retrieve cart token via AJAX:", error);
        return null;
    }
}

async function syncPlannerMetafieldsToCart(cartToken, planUrl, planID, thickness, version) {
  const query = `
    mutation cartMetafieldsSet($metafields: [CartMetafieldsSetInput!]!) {
      cartMetafieldsSet(metafields: $metafields) {
        userErrors {
          field
          message
        }
      }
    }
  `;

  const cartId = `gid://shopify/Cart/${cartToken}`;
  
  // Notice the namespace and key are joined with a dot into the single 'key' field
  const metafieldsPayload = [
    {
      ownerId: cartId,
      key: "matchless_planner.planUrl",
      value: planUrl,
      type: "single_line_text_field"
    },
    {
      ownerId: cartId,
      key: "matchless_planner.countertop_thickness",
      value: String(thickness),
      type: "single_line_text_field"
    }
  ];

  // Dynamically push planID if it exists
  if (planID) {
    metafieldsPayload.push({
      ownerId: cartId,
      key: "matchless_planner.planID",
      value: String(planID),
      type: "single_line_text_field"
    });
  }

  // Dynamically push version if it exists
  if (version) {
    metafieldsPayload.push({
      ownerId: cartId,
      key: "matchless_planner.version",
      value: String(version),
      type: "single_line_text_field"
    });
  }

  try {
    const response = await fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({ query, variables: { metafields: metafieldsPayload } }),
    });
    
    const result = await response.json();
    if (result.errors || result.data?.cartMetafieldsSet?.userErrors?.length) {
      console.error("Storefront API Errors Execution:", result.errors || result.data.cartMetafieldsSet.userErrors);
    } else {
      console.log("Success: All 4 planner variables synced directly to native Cart Metafields.");
    }
  } catch (err) {
    console.error("Critical Network Error handling Storefront Cart Mutation:", err);
  }
}
// ============================================================================


document.addEventListener("alpine:init", () => {
    Alpine.data(
        "mc_handleplanner",
        () => ({
            loading: true,
            apiResponse: null,
            counterThickness: 0.00,
            hasMatchlessTops: false,
            needsValidation: false,
            getCounterDims: false,
            sinkOnly: false,
            showPlanValidation: false,
            items: [],
            attributes: {},
            planUrl: '',
            planID: null,
            hasErrors: false,
            errors: {},
            showHeaderError: false,
            returnLink: '',
            plannerVersion: null,

            init(){
                console.log("Init");
            },
            getPBPlanV2: async function(pId, dId){
              await fetch(window.Shopify.routes.root + "tools/mp/Planner?id="+pId+"&dealer="+dId, {
                  method: 'GET',
                  headers: {'Content-Type': 'application/json'}
              })
                  .then(response => response.json())
                  .then(data => {
                      this.loading = false;
                      this.apiResponse = data;
                      this.processData(data);
                  })
                  .catch((error) => {
                      console.error('Import Plan Error: ', error);
                  });
                return;
            },

            getPBPlan: async function(){
                var urlParams = new URLSearchParams(window.location.search);
                let pId = urlParams.get('pId');
                let dId = urlParams.get('dId');
                let vId = urlParams.get('version');
                this.planID = pId;
                if(vId == "v2"){
                  this.plannerVersion = vId;
                  await this.getPBPlanV2(pId, dId);
                }
                else
                {
                    this.plannerVersion = "v1";
                    await fetch(window.Shopify.routes.root + "tools/mp/Planner?id="+pId+"&dealer="+dId, {
                        type: 'GET',
                        headers: {'Content-Type': 'application/json'}
                    })
                        .then(response => response.json())
                        .then(data => {
                            this.loading = false;
                            this.apiResponse = data;
                            this.processData(data);
                        })
                        .catch((error) => {
                            console.error('Import Plan Error: ', error);
                        });
                }
            },

            processData: function(data){
                var urlParams = new URLSearchParams(window.location.search);
                let vId = urlParams.get('version');
                if(vId != null && vId == "v2"){
                  this.returnLink = data.projectUrl;
                }else{
                  this.returnLink = data.rawProjectResponse.url;
                }

                if(data.hasMatchlessCounters){
                    this.counterThickness = 1.25;
                    this.hasMatchlessTops = true;
                }
                if(data.needCounterDims){
                  this.getCounterDims = true;
                }

                this.planUrl = this.returnLink;
                let overviewImageUrl = "";
                if (data.rawProjectResponse && data.rawProjectResponse.files) {
                    let overviewFile = data.rawProjectResponse.files.find(f => f.name === 'Overview.webp');
                    if (overviewFile) {
                        overviewImageUrl = overviewFile.url;
                    }
                }
                data.items.forEach(element => {
                    // Extract shared attributes securely from the element root mapping node
                    let elementPlanId = element.properties ? (element.properties._planId || element.properties._planID) : null;

                    if(element.sku.substring(0,3)=='RRC'){
                        let newItem = {
                            id: element.variantID,
                            quantity: element.quantity,
                            properties: {
                                '_matchlessBuilderId': element._matchlessBuilderId
                            }
                        };
                        if(elementPlanId) newItem.properties["_planId"] = elementPlanId;

                        if(overviewImageUrl !== "") newItem.properties["_planImage"] = overviewImageUrl;

                        if(element.mainColor != null){
                            newItem.properties["Main Color"] = element.mainColor;
                            newItem.properties["_Main_ColorCode"] = getColorCode(element.mainColor);
                        }
                        if(element.secondaryColor != null){
                            newItem.properties["Door / Drawer Color"] = element.secondaryColor;
                            newItem.properties["_Optional_Door_Drawer_ColorCode"] = getColorCode(element.secondaryColor);
                        }
                        if(element.handles != null){
                            newItem.properties["Pulls"] = element.handles;
                        }
                        for(const prop in element.properties){
                            if(prop != "Cutout"){
                              newItem.properties[prop] = element.properties[prop];
                            }
                            else{
                              newItem.properties["_plannerCutout"] = element.properties["Cutout"];
                            }
                          }
                        if(element.childItems){
                            for(let x=0; x < element.childItems.length; x++){
                              let childItem = {
                                id: element.childItems[x].variantID,
                                quantity: element.childItems[x].quantity,
                                properties: {
                                  '_matchlessBuilderId': element.childItems[x]._matchlessBuilderId
                                }
                              };
                              let childPlanId = element.childItems[x].properties ? (element.childItems[x].properties._planId || element.childItems[x].properties._planID) : elementPlanId;
                              if(childPlanId) childItem.properties["_planId"] = childPlanId;

                              for(const childProp in element.childItems[x].properties){
                                childItem.properties[childProp] = element.childItems[x].properties[childProp];
                              }
                              this.items.push(childItem);
                            }
                          }
                          this.items.push(newItem);
                    }
                    else{
                        if(element.ctrQuantity > 0 || element.sku == 'alum_bartop' || element.sku=='ssteel_bartop'){
                            let newItem = {
                              id: element.variantID,
                              quantity: Math.ceil(element.ctrQuantity),
                              properties: {
                                '_matchlessBuilderId': element._matchlessBuilderId
                              }
                            };
                            if(elementPlanId) newItem.properties["_planId"] = elementPlanId;
                            if(overviewImageUrl !== "") newItem.properties["_planImage"] = overviewImageUrl;
                            if(element.mainColor != null){
                              newItem.properties["Main Color"] = element.mainColor;
                              newItem.properties["_Main_ColorCode"] = getColorCode(element.mainColor);
                            }
                            for(const prop in element.properties){
                                newItem.properties[prop] = element.properties[prop];
                            }
                            this.items.push(newItem);
                          }
                          else{
                            // ============================================================================
                            // CORRECTION: Assign _planId properties explicitly to top-level loose parts & Fillers
                            // ============================================================================
                            let newItem = {
                              id: element.variantID,
                              quantity: element.quantity,
                              properties: {
                                '_matchlessBuilderId': element._matchlessBuilderId
                              }
                            };
                            if(elementPlanId) newItem.properties["_planId"] = elementPlanId;
                            
                            // Map any custom attributes on loose parts cleanly
                            for(const prop in element.properties){
                                newItem.properties[prop] = element.properties[prop];
                            }
                            this.items.push(newItem);
                          }
                    }
                });

                const hasPlannerCutout = this.items.some(item => {
                    return item.properties && item.properties.hasOwnProperty('_plannerCutout');
                });
                if(hasPlannerCutout){
                    if(data.hasNonSinkCutout || (!data.hasNonSinkCutout && data.hasMatchlessCounters)){
                      this.needsValidation = true;
                    }
                }
            },

            getAdditionalData: async function(item){
                if (item.properties?._plannerCutout !== undefined) {
                    this.originalCutout = item.properties._plannerCutout.replace(/\//g, '')
                    .replace(/([xX])/g, ' $1 ') 
                    .replace(/FO/g, 'Front Offset');

                    if(item.properties._plannerCutout.includes('FO') || item.properties._plannerCutout.includes('front_offset'))
                    {
                        this.isSinkType = true;
                        if(!this.hasMatchlessTops){
                          this.hideSink = true;
                        }
                    }

                    let product = this.apiResponse.items.find(x=>x._matchlessBuilderId == item.properties._matchlessBuilderId);

                    if(product.productSlug.includes('farmhouse')){
                        this.isFarmhouseItem = true;
                    }
                    if(product.productSlug.includes('drop-in-burner')){
                        this.isSinkType = false;
                        this.isDropIn = true;
                    }
                    
                    if(product.childItems.length > 0){
                      product.childItems.forEach(i=>{
                        griddleInsertVariants.forEach(e=>{
                          if(e.id == i.variantID){
                            this.originalCutout = e.name;
                            item.properties['Grill Make and Model'] = e.name;
                            this.isInsert = true;
                            this.insertItem = this.items.find(child =>
                              child.properties._matchlessBuilderId == i._matchlessBuilderId && child.id == i.variantID);
                            this.originalInsertVariantId = i.variantID;
                          }
                        });
                        dropKitVariants.forEach(e=>{
                          if(e.id == i.variantID){
                            this.dropKit = true;
                          }
                        });
                        evomountVariants.forEach(e=>{
                          if(e.id == i.variantID){
                            this.originalCutout = e.name;
                            item.properties['Grill Cutout Dimensions'] = e.name;
                            item.properties['Grill Make and Model'] = e.name;
                            this.isFixed = true;
                          }
                        });
                      });
                    }
                    if(!this.isFixed && !this.isInsert && !this.isSinkType && !this.isFarmhouseItem && !this.isDropIn){
                      this.isStandard = true;
                    }
                  
                    await fetch(window.Shopify.routes.root + 'products/'+product.productSlug+'.js',{
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    }).then(response => response.json())
                    .then(async data => {
                        let option = data.variants.find(v=>v.id == item.id);
                        this.shopproduct = data;
                        this.sku = product.sku;
                        this.title = option.title;
                        this.cutouts = product.cutoutMetaFields;
                        this.tallGrill = product.tallGrill;
                        if(this.isInsert){
                          this.allowedInsertVariants = await this.getAllowedInsertVariants(product.productSlug, item.id);
                          this.insertLoadError = '';
                          this.removeError('insert-mapping-' + item.properties._matchlessBuilderId);
                        }
                        this.setLineOptions(product);
                    })
                    .catch((error) => {
                        console.error('Import Plan Error: ', error);
                        if(this.isInsert){
                          this.allowedInsertVariants = [];
                          this.grillOptions.length = 0;
                          this.grillMakeModel = '';
                          this.insertLoadError = 'Unable to load inserts for this cabinet variant. Please reload the plan and try again.';
                          this.addError('insert-mapping-' + item.properties._matchlessBuilderId);
                        }
                    });
                }
            },

            getAllowedInsertVariants: async function(productSlug, variantId){
                const response = await fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(productSlug) +
                  '?variant=' + encodeURIComponent(variantId) + '&view=planner-inserts', {
                    method: 'GET',
                    // Request Liquid rendering, not Shopify's built-in product JSON endpoint.
                    headers: { 'Accept': 'text/html' }
                  });
                if(!response.ok){
                  throw new Error('Unable to load planner insert mapping: HTTP ' + response.status);
                }
                const body = await response.text();
                if(body.trimStart().startsWith('<')){
                  throw new Error('Planner insert mapping view is unavailable. Deploy product.planner-inserts.liquid to the theme being viewed.');
                }
                const data = JSON.parse(body);
                if(!data || String(data.variantId) !== String(variantId) || !Array.isArray(data.inserts) ||
                    data.inserts.some(variant => !variant || !Number.isSafeInteger(variant.id) || variant.id <= 0)){
                  throw new Error('Invalid planner insert mapping for cabinet variant ' + variantId);
                }
                return data.inserts;
            },

            setLineOptions: function(data){
              console.log(data);
              this.grillOptions.length = 0;
              if(!this.isSinkType && !this.isFarmhouseItem && this.counterThickness > 0){
                    let wAdj = 0;
                    let hAdj = 0;
                    if(this.dropKit){
                      wAdj = 3;
                      hAdj = 6;
                    }

                    let height = parseFloat(data.cutoutMetaFields.maxCutoutHeight) + parseFloat(this.counterThickness) - parseFloat(hAdj);
                    let minHeight = parseFloat(data.cutoutMetaFields.minCutoutHeight? data.cutoutMetaFields.minCutoutHeight : 0);

                    let width = parseFloat(data.cutoutMetaFields.maxCutoutWidth - wAdj);
                    let depth = data.cutoutMetaFields.maxCutoutDepth;
                    let ctopcutout = data.cutoutMetaFields.maxCountertopCutout;

                    builtIns.forEach(obj=>{
                        if (data.tallGrill && (parseFloat(obj.CutoutHeight) < 12.75 || parseFloat(obj.CutoutHeight) < minHeight)) {
                          return; 
                        }
                        if(this.isInsert){
                          if(obj.IsInsert && this.allowedInsertVariants.some(variant => variant.id == obj.VariantId) && height >= parseFloat(obj.CutoutHeight)){
                            this.grillOptions.push(obj);
                          }
                          return;
                        }
                        else if(!data.tallGrill && obj.HybridOnly? true: false){
                          return;
                        }
                        else if(obj.IsInsert || obj.IsEvoMount){
                          return;
                        }
                        if(parseFloat(width) >= parseFloat(obj.CutoutWidth) && parseFloat(height) >= parseFloat(obj.CutoutHeight) && parseFloat(depth) >= parseFloat(obj.CutoutDepth) && parseFloat(ctopcutout) >= parseFloat(obj.CountertopCutout)){
                            this.grillOptions.push(obj);
                        }
                    });
                }
            },

            reload: function(event, item){
                this.showOtherDims = this.grillMakeModel === 'Other';
                if(this.cutouts == null){
                  this.grillOptions.length = 0;
                  return;
                }
                this.setLineOptions({
                  cutoutMetaFields: this.cutouts,
                  tallGrill: this.tallGrill
                });
                if((this.isStandard || this.isInsert) && this.grillMakeModel && this.grillMakeModel !== 'Other' &&
                    !this.grillOptions.some(grill => grill.Brand + ' ' + grill.Name === this.grillMakeModel)){
                  this.grillMakeModel = '';
                  this.updatedCutout = '';
                  if(this.isInsert && this.insertItem){
                    this.insertItem.id = this.originalInsertVariantId;
                  }
                  this.removeProperty(item.properties, 'Grill Cutout Dimensions');
                  this.removeProperty(item.properties, 'Grill Make and Model');
                }
            },

            // ============================================================================
            // 100% ATTRIBUTE-FREE SUBMISSION METHODS
            // ============================================================================
            proceed: function(event){
                event.preventDefault();

                this.formValidate();
                if(!this.isValid){
                    return;
                }

                this.attributes = {}; 
                this.clearCart().then(() => this.postCart());
            },

            postCart: async function(){
                let cart = {
                    'items': this.items,
                    'attributes': {}, 
                    'note':''
                };

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(cart)
                })
                .then(response => response.json()) 
                .then(async (cartData) => {
                    if (typeof updateChatCart === "function") {
                        updateChatCart();
                    } 
                    
                    const cartCheckResponse = await fetch(window.Shopify.routes.root + 'cart.js');
                    const realCartObj = await cartCheckResponse.json();
                    const dynamicCartToken = realCartObj.token;

                    if (!dynamicCartToken) {
                        window.location.href = window.Shopify.routes.root + 'cart';
                        return;
                    }

                    await syncPlannerMetafieldsToCart(
                        dynamicCartToken, 
                        this.planUrl, 
                        this.planID,
                        this.counterThickness, 
                        this.plannerVersion
                    );

                    window.location.href = window.Shopify.routes.root + 'cart';
                })
                .catch((error)=>{
                    console.error('Error adding to cart: ', error);
                });
            },

            clearCart: async function(){
                return fetch(window.Shopify.routes.root + 'cart/clear.js',{
                    method: 'POST',
                    headers: { 'Content-Type':'application/json' }
                  });
            },

            validate: function(event)
            {
                let ele = event.target;
                const str = ele.dataset.rules;
        
                if(str != undefined && str != "")
                  {
                  const validJson = str.replace(/'/g, '"');
                  let rules = JSON.parse(validJson);
        
                  if(rules.includes('cutoutDim')){
                    let wAdj = 0;
                    let hAdj = 0;
                    
                    if(this.dropKit){
                      wAdj = 3;
                      hAdj = 6;
                    }
                      
                    let maxRule = '';
                    if(this.cutouts!=null)
                    {
                      let height = parseFloat(this.cutouts.maxCutoutHeight) + parseFloat(this.counterThickness) - hAdj;

                       if(!rules.includes('min:0')){
                          rules.push('min:0');
                        }
                      
                      if(this.dimension === 'width'){
                        maxRule = 'max:'+(this.cutouts.maxCutoutWidth - wAdj);
                      }
                      if(this.dimension === 'depth'){
                        maxRule = 'max:' + this.cutouts.maxCutoutDepth;
                      }
          
                      if(!this.isSink){
                        if(this.dimension === 'height'){
                          maxRule = 'max:'+height;
                        }
                        if(this.dimension === 'front'){
                          maxRule = 'max:'+(this.cutouts.maxCountertopCutout - wAdj);
                        }
                      }
                    }
                    if(this.dimension == 'ctop'){
                      maxRule = 'max:4';
                    }
                      
                    if(maxRule !== '' && !rules.includes(maxRule)){
                      rules.push(maxRule);
                    }
                  }

                  // Persist the computed rules for submit-time validation.
                  ele.dataset.rules = JSON.stringify(rules);
                    
                  this.errorMessage = this.getErrorMessage(ele.value,rules);
                  if(this.errorMessage){
                      this.showMessage = true;
                      this.addError(ele.name);
                  }
                  else{
                      this.removeError(ele.name);
                      this.showMessage = false;
                  }
                }
            },
            getErrorMessage:function(value, rules){
                let isValid = Iodine.assert(value, rules);
                if (isValid.valid !== true) {
                  return isValid.error;
                }
                return '';
            },
            addError(elementName){
                this.errors[elementName] = this.errorMessage;
                this.hasErrors = true;
                this.showHeaderError = true; 
            },
            removeError(elementName){
                delete this.errors[elementName];
                this.hasErrors = Object.keys(this.errors).length > 0;
                if(!this.hasErrors){
                    this.showHeaderError = false;
                }
            },

            formValidate() {
                const alpineComponents = document.querySelectorAll('[data-rules]'); 
                this.isValid = true;
                if(alpineComponents.length > 0){
                  alpineComponents.forEach(component => {
                    const str = component.dataset.rules;
                    if(str != undefined && str != "")
                      {
                      const validJson = str.replace(/'/g, '"');
                      let rules = JSON.parse(validJson);
                      
                      let valid = Iodine.assert(component.value,rules).valid;
                      if(!valid){
                        this.isValid = false;
                        component.dispatchEvent(new CustomEvent('validate')); 
                      }
                    }
                  });
                }
              },

            removeProperty: function(obj, prop) {
              if (obj.hasOwnProperty(prop)) {
                delete obj[prop];
              }
              return obj; 
            },

            checkCtops: function(event){
                if(this.counterThickness !== undefined && this.counterThickness !== null){
                    return true;
                }
                return false;
            },
            cutoutSelected: function(event, item){
                if(this.isInsert){
                  const opt = event.target.options[event.target.selectedIndex];
                  const isKnownInsert = event.target.selectedIndex != 0 && event.target.value !== 'Other';
                  const variants = isKnownInsert ? this.allowedInsertVariants : griddleInsertVariants;
                  const variant = variants.find(candidate =>
                    candidate.id == (isKnownInsert ? opt.dataset.variantid : this.originalInsertVariantId));
                  if(!this.insertItem || !this.items.includes(this.insertItem) || !variant ||
                      (isKnownInsert && !this.grillOptions.some(grill => grill.VariantId == variant.id))){
                    console.error('Unable to map selected planner insert to its cart line item', {
                      variantId: opt.dataset.variantid,
                      builderId: item.properties._matchlessBuilderId
                    });
                    this.grillMakeModel = '';
                    this.updatedCutout = '';
                    this.removeProperty(item.properties, 'Grill Cutout Dimensions');
                    this.removeProperty(item.properties, 'Grill Make and Model');
                    this.errorMessage = 'Unable to update the insert. Please reload the plan and try again.';
                    this.showMessage = true;
                    this.addError(event.target.name);
                    return;
                  }
                  this.insertItem.id = variant.id;
                }
                this.updatedCutout = "";
                if(event.target.selectedIndex != 0 && event.target.value != 'Other'){
                  this.showOtherDims = false;
                  let opt = event.target.options[event.target.selectedIndex]; 
                  let val = opt.value;
                  
                  let cutoutdims = this.isInsert
                    ? opt.dataset.coheight + "in"
                    : opt.dataset.cowidth + "\"W x" + opt.dataset.codepth + "\"D x" + opt.dataset.coheight + "\"H (" + opt.dataset.coctop + "\" Front Panel Width)";
                  this.updatedCutout = cutoutdims;
                  item.properties['Grill Cutout Dimensions'] = cutoutdims;
                  item.properties['Grill Make and Model'] = val;
                }
                else if(event.target.value == 'Other'){
                  this.showOtherDims = true;
                  this.removeProperty(item.properties, 'Grill Cutout Dimensions');
                  this.removeProperty(item.properties, 'Grill Make and Model');
                }
                else{
                  this.showOtherDims = false;
                  this.removeProperty(item.properties, 'Grill Cutout Dimensions');
                  this.removeProperty(item.properties, 'Grill Make and Model');
                }
                this.validate(event);
            },
            grillOtherUpdate: function(event, item){
                this.updatedCutout = "";
                if(this.widthModel != null && this.depthModel != null && this.heightModel != null && this.frontModel != null && this.otherMakeModel != null){
                  let cutoutdims = this.widthModel + 'W x ' + this.depthModel + 'D x' + this.heightModel + 'H (Front Panel Width: ' + this.frontModel + ')';
                  this.updatedCutout = cutoutdims;
                  item.properties['Grill Cutout Dimensions'] = cutoutdims;
                  item.properties['Grill Make and Model'] = this.otherMakeModel;
                }
                else{
                  this.removeProperty(item.properties, 'Grill Cutout Dimensions');
                  this.removeProperty(item.properties, 'Grill Make and Model');
                }
                this.validate(event);
            },
            sinkUpdate: function(event,item){
              this.validate(event);
              let prop1 = "";
              let prop2 = "";
              if(this.isDropIn){
                prop1 = "Drop-In Cutout Dimensions";
                prop2 = "Drop-In Make and Model";
              }
              else{
                prop1 = "Sink Cutout Dimensions";
                prop2 = "Sink Make and Model";
              }
              if(!this.showMessage){
                this.updatedCutout = "";
                if(this.widthModel != null && this.depthModel != null){
                  this.updatedCutout = this.widthModel+"in W x " + this.depthModel+"in D";
                  item.properties[prop1] = this.updatedCutout;
                  item.properties[prop2] = this.otherMakeModel;
                }
              }
              else{
                this.removeProperty(prop1);
                this.removeProperty(prop2);
              }
            },
            farmhouseUpdate: function(event,item){
              this.validate(event);
              if(!this.showMessage){
                if(this.widthModel != null && this.depthModel != null && this.heightModel != null && this.frontModel != null && this.otherMakeModel != null){
                  let cutoutdims = this.widthModel + 'W x ' + this.depthModel + 'D x' + this.heightModel + 'H (Front Panel Width: ' + this.frontModel + ')';
                  this.updatedCutout = cutoutdims;
                  item.properties['Sink Cutout Dimensions'] = cutoutdims;
                  item.properties['Sink Make and Model'] = this.otherMakeModel;
                }
              }else{
                this.removeProperty('Sink Cutout Dimensions');
                this.removeProperty('Sink Make and Model');
              }
            },
            ctopOtherUpdate: function(event){
              this.validate(event);
              if(this.showMessage == false){
                this.ctop=true;
                this.counterThickness = event.target.value;
              }
              else{
                this.ctop = false;
                this.ctopModel = null;
              }
                const alpineComponents = document.querySelectorAll('.import_grid'); 
                alpineComponents.forEach(component => {
                    component.dispatchEvent(new CustomEvent('reload'));
                });
            },
            ctopUpdate: function(event){
                let selectedOption = event.target.options[event.target.selectedIndex]; 
                if(selectedOption.value == 'Other'){
                  this.ctopOther = true;
                  return;  
                }
                this.ctopOther = false;
                this.ctopModel = null;
                if(event.target.selectedIndex !=0){
                  this.counterThickness = selectedOption.dataset.inches;
                }
                else{
                  this.counterThickness = null;
                  this.ctop = false;
                  this.showOtherDims = false;
                }
                const alpineComponents = document.querySelectorAll('.import_grid'); 
                alpineComponents.forEach(component => {
                    component.dispatchEvent(new CustomEvent('reload'));
                });
                this.validate(event);
            },
        })
    );
});